__turbopack_context__.v({
  "applyBtn": "ScholarshipHeroBanner-module-scss-module__vx0GXG__applyBtn",
  "badge": "ScholarshipHeroBanner-module-scss-module__vx0GXG__badge",
  "bannerCard": "ScholarshipHeroBanner-module-scss-module__vx0GXG__bannerCard",
  "card": "ScholarshipHeroBanner-module-scss-module__vx0GXG__card",
  "cardTitle": "ScholarshipHeroBanner-module-scss-module__vx0GXG__cardTitle",
  "cardTop": "ScholarshipHeroBanner-module-scss-module__vx0GXG__cardTop",
  "content": "ScholarshipHeroBanner-module-scss-module__vx0GXG__content",
  "ctaButton": "ScholarshipHeroBanner-module-scss-module__vx0GXG__ctaButton",
  "description": "ScholarshipHeroBanner-module-scss-module__vx0GXG__description",
  "eligibilityLabel": "ScholarshipHeroBanner-module-scss-module__vx0GXG__eligibilityLabel",
  "eligibilityText": "ScholarshipHeroBanner-module-scss-module__vx0GXG__eligibilityText",
  "grid": "ScholarshipHeroBanner-module-scss-module__vx0GXG__grid",
  "header": "ScholarshipHeroBanner-module-scss-module__vx0GXG__header",
  "heading": "ScholarshipHeroBanner-module-scss-module__vx0GXG__heading",
  "heroImage": "ScholarshipHeroBanner-module-scss-module__vx0GXG__heroImage",
  "iconBox": "ScholarshipHeroBanner-module-scss-module__vx0GXG__iconBox",
  "imageWrapper": "ScholarshipHeroBanner-module-scss-module__vx0GXG__imageWrapper",
  "section": "ScholarshipHeroBanner-module-scss-module__vx0GXG__section",
  "subtitle": "ScholarshipHeroBanner-module-scss-module__vx0GXG__subtitle",
  "title": "ScholarshipHeroBanner-module-scss-module__vx0GXG__title",
  "white": "ScholarshipHeroBanner-module-scss-module__vx0GXG__white",
  "wrapper": "ScholarshipHeroBanner-module-scss-module__vx0GXG__wrapper",
  "yellow": "ScholarshipHeroBanner-module-scss-module__vx0GXG__yellow",
});
